export default __webpack_public_path__ + "static/media/darknet-icon.d40a499e.svg";